import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HomePage } from "./homepage";
import { ContactPage } from "./contact";
import { CareerPage } from './career';
import PropertiesPage from './properties';
import AboutPage from './aboutus';
import AwardsPage from './awards';
// import DirectorsPage from './directors';
import MissionPage from './mission';
import CertificationPage from './certification';
import DigitalPage from './digitalization';
import CovidPage from './covidcompliant';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Router = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/career" element={<CareerPage />} />
      <Route path="/properties" element={<PropertiesPage />} />
      <Route path="/aboutus" element={<AboutPage />} />
      {/* <Route path="/directors" element={<DirectorsPage />} /> */}
      <Route path="/awards" element={<AwardsPage />} />
      <Route path="/mission" element={<MissionPage />} />
      <Route path="/certification" element={<CertificationPage />} />
      <Route path="/digitalization" element={<DigitalPage />} />
      <Route path="/covidcompliant" element={<CovidPage />} />
    </Routes>
  </BrowserRouter>
);

export default Router;
